var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergyStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09766 17.3477L7.75 10.4727H5.90234V5.40234L2.25 12.2773H4.09766V17.3477ZM8.35156 2.65234C8.69531 2.65234 8.98177 2.78125 9.21094 3.03906C9.46875 3.26823 9.59766 3.55469 9.59766 3.89844V17.9492C9.59766 18.293 9.46875 18.5794 9.21094 18.8086C8.98177 19.0378 8.69531 19.1523 8.35156 19.1523H1.64844C1.30469 19.1523 1.00391 19.0378 0.746094 18.8086C0.516927 18.5794 0.402344 18.293 0.402344 17.9492V3.89844C0.402344 3.55469 0.516927 3.26823 0.746094 3.03906C1.00391 2.78125 1.30469 2.65234 1.64844 2.65234H3.15234V0.847656H6.84766V2.65234H8.35156Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyStorage);
export default __webpack_public_path__ + "static/media/EnergyStorage.46ede1becf14438a5bb312f2e70a0816.svg";
export { ForwardRef as ReactComponent };